import React from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import UserSummaryContent from './UserSummaryContent';

const UserSummaryDialog = ({ open, user, allUsers, onClose }) => {
  const navigate = useNavigate();

  if (!open || !user) return null;

  const userId = user.id || user._id;

  const handleOpenFullPage = () => {
    onClose();
    navigate(`/users/${userId}/summary`);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '92vh',
          bgcolor: '#f8fafc',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          overflow: 'hidden'
        }
      }}
    >
      <DialogContent sx={{ p: 3, overflowY: 'auto' }}>
        <UserSummaryContent
          userId={userId}
          initialUser={user}
          allUsers={allUsers}
          isModal={true}
          onClose={onClose}
          onOpenFullPage={handleOpenFullPage}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UserSummaryDialog;
